module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-set-bed8adeecea7ac6e5c52d53b9074eeae.svg";